import { render, staticRenderFns } from "./HeaderGroupComponent.vue?vue&type=template&id=f48603dc"
import script from "./HeaderGroupComponent.vue?vue&type=script&lang=js"
export * from "./HeaderGroupComponent.vue?vue&type=script&lang=js"
import style0 from "./HeaderGroupComponent.vue?vue&type=style&index=0&id=f48603dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports